import { Alert, Button, Group, Modal, Paper, PasswordInput, Stack, Text, Title } from '@mantine/core';
import { IconDownload, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDeleteAccount } from '@/api/account';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';

/** Datenschutz (PROF-05): Export aller eigenen Daten und Löschen des Kontos. */
export function PrivacySection() {
  const { t } = useTranslation();
  const { user } = useCurrentWorkspace();
  const navigate = useNavigate();
  const remove = useDeleteAccount();
  const onError = useApiError();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  return (
    <Paper withBorder p="md">
      <Title order={5} mb="xs">
        {t('privacy.title')}
      </Title>
      <Text size="sm" c="dimmed" mb="sm">
        {t('privacy.exportHint')}
      </Text>
      <Group>
        <Button component="a" href="/api/v1/me/personal-data" download variant="default" leftSection={<IconDownload size={16} />}>
          {t('privacy.export')}
        </Button>
        <Button color="red" variant="light" leftSection={<IconTrash size={16} />} onClick={() => setOpen(true)}>
          {t('privacy.delete')}
        </Button>
      </Group>
      <Modal opened={open} onClose={() => setOpen(false)} title={t('privacy.deleteTitle')}>
        <Stack>
          <Alert color="red">{t('privacy.deleteText')}</Alert>
          {user.hasPassword && (
            <PasswordInput label={t('profile.currentPassword')} value={password} onChange={(e) => setPassword(e.currentTarget.value)} data-autofocus />
          )}
          <Group justify="flex-end">
            <Button variant="default" onClick={() => setOpen(false)}>
              {t('common.cancel')}
            </Button>
            <Button
              color="red"
              disabled={user.hasPassword && !password}
              loading={remove.isPending}
              onClick={() => remove.mutate(password, { onSuccess: () => navigate('/login?deleted=1'), onError })}
            >
              {t('privacy.deleteConfirm')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Paper>
  );
}
